import { Language, getToken, ListResponse, Order } from "helpers";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { ParkingResponse } from "./apiHelpers";

export const parkingApi = createApi({
  reducerPath: "parkingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/catalog/parking/manage`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getParkings: builder.query<ParkingResponse, ListParkingsOptions>({
      query: ({ page = 0, pageSize = 5, search, sort, order, company_id, municipality_id }) => ({
        url: `list`,
        params: {
          page: page + 1,
          pageSize,
          search: search ? search.replace(/ /g, "-") : undefined,
          sort,
          order,
          company_id,
          municipality_id,
        },
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),

    updateParking: builder.mutation<void, UpdateParkingRequest>({
      query: ({ parking_id, lang, data }) => ({
        url: ``,
        params: {
          parking_id,
          lang,
        },
        method: "POST",
        body: data,
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

export const {
  useGetParkingsQuery,
  useLazyGetParkingsQuery,
  useUpdateParkingMutation,
  usePrefetch: useParkingApiPrefetch,
} = parkingApi;

interface ListParkingsOptions {
  page?: number;
  pageSize?: number;
  search?: string;
  sort?: string;
  order?: Order;
  company_id?: string;
  municipality_id?: string;
}

interface UpdateParkingRequest {
  parking_id: string;
  lang: Language;
  data: {
    parking_name_mk: string;
    parking_name_al: string;
    parking_name_en: string;
    longitude: string;
    latitude: string;
    municipality_id: number;
    area_type: string;
    total_parking_slots: number;
    payment_options: number[];
    amenities: number[];
  };
}
